module.exports = __webpack_public_path__ + "media/that-was-quick-606.04f5e8cc.mp3";